import * as apisBlog from './specs/blog.api'
import * as apisMain from './specs/main.api'
import * as apisOpen from './specs/open.api'
import * as apisPay from './specs/pay.api'

export { ApiError } from './helpers'

export { apis, apisBlog, apisOpen, apisPay }

const apis = apisMain
